import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import { Flex } from 'reflexbox'
import { Button } from 'react-toolbox/lib/button'

import withRedirectLink from 'components/fulcrum/link/FulcrumReactRouterLink'

import styles from './styles.scss'

const NextButton = withRedirectLink(Button)

const Actionbar = ({ styles, id, ...rest }) => {
  return (
    <Flex flex justify='flex-end' styleName='actionBar'>
      <NextButton
        {...rest}
        to={`/project/${id}/review`}
        label='Next'
        primary
        raised
        ripple
      />
    </Flex>
  )
}

Actionbar.propTypes = {
  onClick: PropTypes.func,
  id: PropTypes.string.isRequired,
}

Actionbar.defaultProps = {
  id: '',
}

export default CSSModules(Actionbar, styles)
